import { createSlice } from '@reduxjs/toolkit'
import { fetchGroupings, fetchTbLibData, fetchGrpLibUserData, fetchGrpLibData } from './reports/thunks/grouping'

const initialState = {
    openModal: false,
    roundOffTb: false,
    jsonData: [],
    validColumn: false,
    isFilePicked: false,
    selectedFile: "",
    excelId: "",
    groupings: null,
    tbLibData: null,
    userGrpLibData: [],
    grpLibData: []
}

const groupingSlice = createSlice({
  name: 'GROUPINGSLICE',
  initialState,
  reducers: {
    modalState(state, action){
        state.openModal = action.payload
    },
    roundoffState(state, action){
        state.roundOffTb = action.payload
    },
    columnValidState(state, action){
        state.validColumn = action.payload
    },
    formattedJsonData(state, action){
        state.jsonData = action.payload
    },
    filePickedState(state, action){
        state.isFilePicked = action.payload
    },
    selectedFileState(state, action){
        state.selectedFile = action.payload
    },
    uploadedExcelId(state, action){
        state.excelId = action.payload
    }
  },
   extraReducers: (builder) => {
        builder.addCase(fetchGroupings.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchGroupings.fulfilled, (state, action) => {
            state.isLoading = false
            state.groupings = action.payload
        })
        builder.addCase(fetchGroupings.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
            state.groupings = null
        })
        builder.addCase(fetchTbLibData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchTbLibData.fulfilled, (state, action) => {
            state.isLoading = false
            state.tbLibData = action.payload
        })
        builder.addCase(fetchTbLibData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
            state.tbLibData = null
        })
        builder.addCase(fetchGrpLibUserData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchGrpLibUserData.fulfilled, (state, action) => {
            state.isLoading = false
            state.userGrpLibData = action.payload
        })
        builder.addCase(fetchGrpLibUserData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
        builder.addCase(fetchGrpLibData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchGrpLibData.fulfilled, (state, action) => {
            state.isLoading = false
            state.grpLibData = action.payload
        })
        builder.addCase(fetchGrpLibData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
    }
})

// Action creators are generated for each case reducer function
export const { modalState, roundoffState, columnValidState, formattedJsonData, filePickedState, selectedFileState, uploadedExcelId } = groupingSlice.actions

export default groupingSlice;